import { WebClientListResourceFetcher } from '../../commonInfra/utils/resourceFetchers/WebClientListResourceFetcher';
import { IListFetcher } from '../../ts/fetchers/IListFetcher';
import { ServerApiMapper } from '../../ts/helpers/ServerModelHelper';
import { ITableInfo } from '../../ts/models/ITableInfo';
import { GetTablesRequest } from '../../ts/ServerApi/requests/GetTablesRequest';
import { IListResource } from '../../ts/resources/Resource';
import { ResourceQuery } from '../../ts/resources/ResourceQuery';


class TablesWithCrassResource implements IListResource<ITableInfo> {

  private listFetcher: IListFetcher<ITableInfo> = new WebClientListResourceFetcher(GetTablesRequest, ServerApiMapper.tablesUsingCrass);

  public all(): ResourceQuery<ITableInfo> {
    return new ResourceQuery(this.listFetcher);
  }
}

export const TablesWithCrass = new TablesWithCrassResource();
export type TablesWithCrass = typeof TablesWithCrass;
